import React from "react";

const Delievery = () => {
  return (
    <div>
      <h1>RETURNS & EXCHANGES</h1>
      <h2>WHAT IS YOUR RETURN OR EXCHANGE POLICY?</h2>
      <p>
        You have 10 days from the date of delivery to claim for the
        return or exchange if :
      </p>
      <ul>
        <li>
          The product is damaged, stained, defected or incomplete.
        </li>
        <li>
          The product/s must be unused, in the original packaging with
          labels and protective stickers attached.
        </li>
        <li>The product received does not match the size ordered.</li>
        <li>
          Products purchased directly from our website must be
          returned to our Customer Services department for a return
          and full refund to be made. Unfortunately, online purchases
          cannot currently be returned in-store.
        </li>
        <li>
          his is only applicable for orders delivered within Pakistan,
          for international orders please contact our customer support
          team and we will try to help you out in a possible way.
        </li>
        <li>
          Please be advised that inner-wear products are
          non-returnable/exchangeable due to the nature of the
          products and to maintain hygiene standards.
        </li>
        <li>
          Fragrances, cosmetics, jewelry are neither exchangeable nor
          returnable.{" "}
        </li>
        <li>
          Exchanges and refunds during a sale or on a discounted
          product are ONLY applicable if the product received does not
          match the product you have ordered.
        </li>
      </ul>
      <h2>HOW DO I APPLY FOR THE RETURN?</h2>
      <ul>
        <li>
          To return an item, please email us at
          eshop@junaidjamshed.com with the return reason and order
          details.
        </li>
        <li>
          Once our customer support team approves the return you will
          be requested to send the parcel to, Ecommerce Department,
          Junaid Jamshed Pvt. Ltd., Head office, 40 Sector 19 Korangi
          Industrial Area.
        </li>
        <li>
          lease note that you are responsible for the cost of
          returning the items to us.
        </li>
        <li>
          There might be cases where our customer support team will
          route you to nearest J. Outlets for exchange.
        </li>
      </ul>
      <h2>WHEN WILL MY RETURN BE PROCESSED?</h2>
      <ul>
        <li>
          We aim to process all returns with 5-7 working days of
          receipt.
        </li>
        <li>
          During busy periods please allow up to 14 working days for
          your return to be processed.
        </li>
      </ul>
      <h2>WHAT IS YOUR SIZE EXCHANGE POLICY?</h2>
      <ul>
        <li>
          In the event you are unsatisfied with the size you purchase
          and would like to receive a different size, you are most
          welcome to send back your purchase back to E-commerce team
          by contacting us via email at eshop@junaidjamshed.com within
          10 days of the delivery date.
        </li>
        <li>
          The product/s must be unused, in the original packaging with
          labels and protective stickers attached.
        </li>
        <li>
          There might be cases where our customer support team will
          route you to nearest J. Outlets for exchange.
        </li>
        <li>
          This is only applicable for orders delivered within
          Pakistan, for international orders please contact our
          customer support team and we will try to help you out in a
          possible way.
        </li>
      </ul>
      <h2>DO YOU OFFER REFUND?</h2>
      <ul>
        <li>
          Unfortunately, we don't offer any refunds. However, In the
          case where we won't be able to offer an exchange or any
          solution we may offer a refund.
        </li>
        <li>
          Any online payments received by J. is in PKR, therefore, in
          case of refunds amount will be reversed/refunded in PKR.
        </li>
        <li>
          Customer will be responsible for any changes in currency
          exchange rates.
        </li>
        <li>
          J. Will not be responsible for any difference of amount due
          to currency conversions
        </li>
        <li>
          In the case of REFUND shipping and handling charges will not
          be refunded.{" "}
        </li>
        <li>
          The minimum period for processing refund is 7-10 working
          days depending on the mode of payment.
        </li>
      </ul>
      <h3>RETURNS: OUR ADDITIONAL POLICY</h3>
      <h3>RETURNS: CUSTOMIZED & MAKE TO ORDERS</h3>
      <p>
        Customized orders include alterations and made to measure
        products which CANNOT be refunded or exchanged. However, if
        you received an incorrect measurement you can send us
        pictorial evidence of the error in alterations and we will try
        to fix the issue.
      </p>
      <h3>RETURNS: SALE & DISCOUNTED ORDERS</h3>
      <p>
        Exchanges and refunds during a sale or on a discounted product
        are ONLY applicable if the product received does not match the
        product you have ordered.
      </p>
    </div>
  );
};

export default Delievery;
